import { formGroupMessagesComponentModule } from '../form-group-messages/form-group-messages';

export const loginVerificationComponentModule = angular
  .module('Q.components.forms.login-verification', [
    formGroupMessagesComponentModule,
  ])

  .directive('loginVerification', function (FORM_GROUP_MESSAGES) {
    FORM_GROUP_MESSAGES.add('incorrectPassword', 'Incorrect current password.');

    return {
      require: 'ngModel',
      link: function (scope, element, attrs, ngModel) {
        function setValidity(obj) {
          angular.forEach(obj, (val, key) => {
            ngModel.$setValidity(key, !val);
          });
        }

        scope.$watch(attrs.loginVerification, function (newValue, oldValue) {
          if (oldValue !== newValue) {
            setValidity(newValue);
          }
        });
        setValidity(scope.$eval(attrs.loginVerification));
      },
    };
  });
